import moment from "moment";

export const lastLoginBodyTemplate = (rowData) => {
  if (!rowData.last_login_at) {
    return "--";
  }
  const lastLoginTime = moment.utc(rowData.last_login_at).local();
  const currentTime = moment().local();
  const isCurrentlyLoggedIn = currentTime.diff(lastLoginTime, "seconds") <= 5;

  return isCurrentlyLoggedIn
    ? "Currently Logged In"
    : lastLoginTime.format("DD/MM/YYYY h:mm:ss A");
};

export const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

export const validatePassword = (password) => {
  const regex = /^(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
  return regex.test(password);
};

export const preventNegativeValue = (value) => {
  return value >= 0;
};

export const limitToTwoDecimalPlaces = (value) => {
  return value.match(/^\d*(\.\d{0,2})?$/);
};

export function formatNumber(x) {
  if (isNaN(x)) return x;

  const isNegative = x < 0;
  const absoluteValue = Math.abs(x).toString();
  const parts = absoluteValue.split(".");

  let integerPart = parts[0];

  const reversed = integerPart.split("").reverse();

  let formatted = "";
  for (let i = 0; i < reversed.length; i++) {
    if (i > 0 && i % 3 === 0) {
      formatted += "'";
    }
    formatted += reversed[i];
  }

  formatted = formatted.split("").reverse().join("");

  const result = parts.length > 1 ? `${formatted}.${parts[1]}` : formatted;

  return isNegative ? `-${result}` : result;
}

export const truncateText = (text, maxChars) => {
  if (text.length > maxChars) {
    return text.slice(0, maxChars) + " ...";
  }
  return text;
};

export function truncateToTwoDecimals(value) {
  if (isNaN(value)) return "-";
  return (Math.floor(value * 100) / 100)?.toFixed(2);
}